/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { useEffect } from 'react';
import { useLocation } from 'react-router';

export function RestoreScroll() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}
